import { Card, CardBody, Col } from "reactstrap";
import CommonCardFooter from "../Common/CommonCardFooter";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { SolidBorderStyles } from "../../../../Constant";
import { SOLID_BORDER_STYLE } from "../../../../Data/FormControl/MegaOptions";
import SolidBorderStyleForm from "./SolidBorderStyleForm";

const SolidBorderStyle = () => {
  return (
    <Col sm="12" xxl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={SolidBorderStyles} span={SOLID_BORDER_STYLE} />
        <CardBody>
          <SolidBorderStyleForm />
        </CardBody>
        <CommonCardFooter footerClass="text-end" color1="primary" color2="light"/>
      </Card>
    </Col>
  )
};

export default SolidBorderStyle;
